// Action Types
export const FETCH_NEWS_REQUEST = "FETCH_NEWS_REQUEST";
export const FETCH_NEWS_SUCCESS = "FETCH_NEWS_SUCCESS";
export const FETCH_NEWS_FAILURE = "FETCH_NEWS_FAILURE";

// Action Creators
export const fetchNewsRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_NEWS_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchNewsSuccess = (data) => ({
  type: FETCH_NEWS_SUCCESS,
  payload: data,
});
export const fetchNewsFailure = (error) => ({
  type: FETCH_NEWS_FAILURE,
  payload: error,
});
